import has from 'lodash/has';
import get from 'lodash/get';
import * as Sentry from '@sentry/react';
import { setNestedObjectValue } from 'tradera/utils/set-nested-object-value';
import {
    TRACK_REDUX_ACTIONS,
    SAVE_REDUX_STATE_PATHS,
} from 'tradera/constants/sentry-redux-filters';

export const actionTransformer = (action) =>
    TRACK_REDUX_ACTIONS.includes(action.type) ? action : null;

export const stateTransformer = (state) =>
    SAVE_REDUX_STATE_PATHS.reduce((sentryState, keyString) => {
        const keyArray = keyString.split('.');
        if (has(state, keyArray)) {
            const value = get(state, keyArray);
            setNestedObjectValue(sentryState, keyArray, value);
        }

        return sentryState;
    }, {});

export const sentryReduxEnhancer = Sentry.createReduxEnhancer({
    actionTransformer,
    stateTransformer,
});
